/**
 * UI DocuSign — módulo desativado em 2026-08-02 (v1).
 *
 * Por defeito a UI de envio/CTA DocuSign fica oculta (alinhado à API com
 * RpaWebhookDocuSign:Enabled=false / DocuSign:Enabled=false → 410).
 *
 * Reativar sem rebuild de ramos: definir REACT_APP_DOCUSIGN_ENABLED=true
 * e ligar as flags Enabled=true na GettelApi. Histórico (leitura) pode
 * permanecer visível mesmo com envio desligado.
 */
export const isDocusignUiEnabled = (): boolean =>
  process.env.REACT_APP_DOCUSIGN_ENABLED === 'true';
